import permissions from '../../permissions'

const INTEGRATION_PARTNER_WEBHOOK_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.INTEGRATION_PARTNER_WEBHOOKS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.INTEGRATION_PARTNER_WEBHOOKS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.INTEGRATION_PARTNER_WEBHOOKS.DESTROY,
  },
]

export default INTEGRATION_PARTNER_WEBHOOK_LIST
